import { Spinner } from "@heroui/react";
import { useTranslation } from "react-i18next";
import GeometricBackground from "./GeometricBackground";

const AppLoading = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-screen w-screen items-center justify-center bg-brand">
      <GeometricBackground />
      <div className="flex flex-col items-center animate-fadein">
        <div className="relative size-24">
          <Spinner
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 size-32 text-accent-blue"
            color="current"
          />
        </div>
        <h1
          className="text-5xl pb-0 mt-16 font-light tracking-wider uppercase
          bg-clip-text text-center m-0 text-white/90"
        >
          ID<span className="font-black text-accent-yellow">CAT</span>
        </h1>

        <p className="mt-4 text-brand-foreground text-sm max-w-sm text-center m-0 animate-pulse">
          {t("loading::Please wait while we prepare everything for you")}
        </p>
      </div>
    </div>
  );
};

export default AppLoading;
